import { createSelector } from '@ngrx/store';
import { selectEntidadesProductivaIsLoading } from '../empresas/entity-entidad-productiva/entity-entidades-productiva.selectors';
import { selectPersonasFisicaIsLoading } from '../empresas/entity-personas-fisica/entity-personas-fisica.selectors';
import { selectPersonasJuridicaIsLoading } from '../empresas/entity-personas-juridica/entity-personas-juridica.selectors';
import { selectPersonasIsLoading } from '../persona/entity-personas/entity-personas.selectors';
import { selectUsuario, selectUsuarioIsLoading } from '../persona/entity-usuarios/entity-usuarios.selectors';
import { selectRolIsLoading } from '../roles/entity-roles/entity-roles.selectors';
import { selectTecnicosIsLoading } from '../roles/entity-tecnicos/entity-tecnicos.selectors';
import { selectTecnicoResponsableIsLoading } from '../roles/entity-tecnico-responsable/entity-tecnico-responsable.selectors';
import { selectDepositosIsLoading } from '../actividades/entity-depositos/depositos.selectors';
import { selectLaboratoriosIsLoading } from '../actividades/entity-laboratorios/laboratorios.selectors';
import { selectSitiosProcesamientoIsLoading } from '../actividades/entity-sitios-procesamiento/sitios-procesamiento.selectors';
import { selectViverosGrupoEspecieIsLoading } from '../actividades/entity-viveros-grupo-especie/entity-viveros-grupo-especie.selectors';
import { selectIntegranteIsLoading } from '../roles/entity-integrante/entity-integrante.selectors';
import { selectMaquinaMovilIsLoading } from '../actividades/entity-maquinas-moviles/entity-maquina-movil.selectors';
import { selectSexosIsLoading } from '../persona/entity-sexo/entity-sexo.selectors';

export const actividadesLoading = createSelector(
  selectDepositosIsLoading,
  selectLaboratoriosIsLoading,
  selectSitiosProcesamientoIsLoading,
  selectViverosGrupoEspecieIsLoading,
  selectIntegranteIsLoading,
  selectMaquinaMovilIsLoading,
  selectViverosGrupoEspecieIsLoading,
  (depositos, laboratorios, sitiosProcesamiento, viverosGrupoEspecie, integranteLoading, maquinaMovilLoading, selectViverosGrupoEspecieIsLoading) => {
    return depositos || laboratorios || sitiosProcesamiento || viverosGrupoEspecie || integranteLoading || maquinaMovilLoading || selectViverosGrupoEspecieIsLoading;
  }
)

export const selectIsLoadingItems = createSelector(
  selectPersonasIsLoading,
  selectUsuarioIsLoading,
  selectEntidadesProductivaIsLoading,
  selectPersonasFisicaIsLoading,
  selectPersonasJuridicaIsLoading,
  selectRolIsLoading,
  selectTecnicosIsLoading,
  selectTecnicoResponsableIsLoading,
  (
    personasIsLoading,
    user,
    entidadesProductivaIsLoading,
    personasFisicaIsLoading,
    personasJuridicaIsLoading,
    rolesIsLoading,
    tecnicoIsLoading,
    tecnicoResponsableIsLoading,
  ) => {
    return (
      personasIsLoading ||
      user ||
      entidadesProductivaIsLoading ||
      personasFisicaIsLoading ||
      personasJuridicaIsLoading ||
      rolesIsLoading ||
      tecnicoIsLoading ||
      tecnicoResponsableIsLoading
    );
  }
);

export const items2IsLoading = createSelector(
  selectSexosIsLoading,
  (sexosIsLoading) => {
    return sexosIsLoading;
  }
);
